"use strict";

exports.__esModule = true;
exports.SingleDeviceGrid = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _reactIntl = require("react-intl");
var _reactRouterDom = require("react-router-dom");
var _DeviceContext = require("../../Device/DeviceContext");
var _DeviceListContext = require("../../Device/DeviceListContext");
var _ManualEventsContext = require("../../Operator/ManualEventsContext");
var _UserActions = require("../../UserActions");
var _SelectionContext = require("../SelectionContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function renderWithClickAction(_ref) {
  var onClickAction = _ref.onClickAction,
    props = _ref.props;
  return /*#__PURE__*/_react["default"].createElement(_ManualEventsContext.ManualEventSupplier, null, /*#__PURE__*/_react["default"].createElement(_UserActions.UserAction, onClickAction, function (_ref2) {
    var getURL = _ref2.getURL,
      invoke = _ref2.invoke;
    // This should not happen as per design. When onClickAction is provided either link or invoke must exist
    if (!getURL && !invoke) {
      return /*#__PURE__*/_react["default"].createElement(_SelectionContext.SelectionContextElement, props);
    }
    if (invoke) {
      return /*#__PURE__*/_react["default"].createElement(_SelectionContext.SelectionContextElement, _extends({}, props, {
        onClick: invoke
      }));
    }
    return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
      to: getURL()
    }, /*#__PURE__*/_react["default"].createElement(_SelectionContext.SelectionContextElement, props));
  }));
}
var SingleDeviceGrid = exports.SingleDeviceGrid = function SingleDeviceGrid(props) {
  var onClickAction = props.onClickAction,
    _props$width = props.width,
    width = _props$width === void 0 ? 256 : _props$width,
    _props$height = props.height,
    height = _props$height === void 0 ? 128 : _props$height;
  var allDevices = _react["default"].useContext(_DeviceListContext.DeviceListContext);
  allDevices = allDevices.filter(function (d) {
    return d.enabled;
  });
  var device = allDevices.find(function (d) {
    return d.uuid === props.device;
  });
  if (!device) {
    return /*#__PURE__*/_react["default"].createElement(_core.NonIdealState, {
      style: {
        width: width,
        height: height
      },
      title: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "SingleDeviceGrid.deviceNotInFilter",
        defaultMessage: "Device not selected in filter"
      })
    });
  }
  if (onClickAction) {
    return /*#__PURE__*/_react["default"].createElement(_DeviceContext.DeviceContext.Provider, {
      value: device
    }, renderWithClickAction({
      onClickAction: onClickAction,
      props: props
    }));
  }
  return /*#__PURE__*/_react["default"].createElement(_DeviceContext.DeviceContext.Provider, {
    value: device || allDevices[0]
  }, /*#__PURE__*/_react["default"].createElement(_SelectionContext.SelectionContextElement, props));
};